import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesBanners } from "../../constants";
import { DeleteBannerResponse } from "./deleteBanner.types";

export const requestDeleteBanner = async (
  bannerId: string
): Promise<DeleteBannerResponse> => {
  return await instance.delete(buildUrl(ApiRoutesBanners.Banners, bannerId));
};
